module.exports = __webpack_public_path__ + "static/media/right_arrow.589c4c0d.svg";